// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"8521e656","626":"1c74ab20","952":"ec0b60c1"}[chunkId] + ".chunk.js";
};